// extracted by mini-css-extract-plugin
export default {"component":"New_KeyboardComponent_component__gpmTb","line":"New_KeyboardComponent_line__zDsAI"};